import { CacheableDataObject } from './CacheableDataObject.jsx';
import { GameRoom } from './GameRoom.jsx';

export class PreferredGame extends CacheableDataObject {

	get ladder() {
		return this.gameRoom;
	}

	get enabled() {
		return this.isEnabled();
	}

	isEnabled() {
		return this.filtered_on;
	}

	setEnabled(value) {
		this.filtered_on = value;
	}
}

PreferredGame.prototype.dataLocationParsers = {
	id: (game, data) => {
		game.id = data.id;
		game.gameRoom = GameRoom.retrieveById(game.id);
	}
};